module.exports = __webpack_public_path__ + "img/stack-with-box.d37c6a9e.svg";